import React from "react";

export default React.memo(() => {
  return (
    <svg
      width="100"
      height="47"
      viewBox="0 0 100 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.5 47C36.4787 47 47 36.4787 47 23.5C47 10.5213 36.4787 0 23.5 0C10.5213 0 0 10.5213 0 23.5C0 36.4787 10.5213 47 23.5 47Z"
        fill="#FF6A10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1499 14.8482V5.17001H25.8499V14.8482C27.4753 13.7819 29.4144 13.16 31.4899 13.16C37.171 13.16 41.8299 17.8189 41.8299 23.5C41.8299 29.1811 37.171 33.84 31.4899 33.84C29.4144 33.84 27.4753 33.2182 25.8499 32.1518V41.83H21.1499V32.1518C19.5246 33.2182 17.5855 33.84 15.5099 33.84C9.82883 33.84 5.16992 29.1811 5.16992 23.5C5.16992 17.8189 9.82883 13.16 15.5099 13.16C17.5855 13.16 19.5246 13.7819 21.1499 14.8482ZM21.1499 23.5C21.1499 20.4147 18.5953 17.86 15.5099 17.86C12.4246 17.86 9.86992 20.4147 9.86992 23.5C9.86992 26.5854 12.4246 29.14 15.5099 29.14C18.5953 29.14 21.1499 26.5854 21.1499 23.5ZM25.8499 23.5C25.8499 26.5854 28.4046 29.14 31.4899 29.14C34.5753 29.14 37.1299 26.5854 37.1299 23.5C37.1299 20.4147 34.5753 17.86 31.4899 17.86C28.4046 17.86 25.8499 20.4147 25.8499 23.5Z"
        fill="white"
      />
      <path
        d="M69.2 38.1C62.3 38.1 60 33 60 28V20.2C60 15.1 62.3 10 69.2 10C76.1 10 78.4 15.1 78.4 20.1V27.9C78.3 33 76 38.1 69.2 38.1ZM75.8 20.2C75.8 15.9 74.1 12.4 69.1 12.4C64.1 12.4 62.4 16 62.4 20.2V28C62.4 32.3 64.1 35.8 69.1 35.8C74.1 35.8 75.8 32.2 75.8 28V20.2ZM91.1 26.5H84.7V36.8C84.7 37.5 84.2 38 83.5 38C82.8 38 82.3 37.5 82.3 36.8V11.6C82.3 10.9 82.9 10.4 83.5 10.4H90.7C97.1 10.4 99.4 14.1 99.4 17.6V19.5C99.4 23.6 96.3 26.5 91.1 26.5ZM96.9 17.6C96.9 15.4 95.5 12.7 90.6 12.7H84.7V24.3H91C95 24.3 96.9 22.1 96.9 19.5V17.6Z"
        fill="#6E6E6E"
      />
    </svg>
  );
});
